export const TYPES = {
  APP: 'APP',
  APPLICATIONS: 'APPLICATIONS',
  USERS: 'USERS',
  ACTIVITY: 'ACTIVITY',
  TEAMS: 'TEAMS',
};
